import { Button } from 'reactstrap';

interface Error404PageProps {
  hideGoHome?: boolean;
}

const Error404Page = ({ hideGoHome = false }: Error404PageProps) => (
  <div data-testid="not-found-container" className="not-found">
    <div data-testid="not-found-blob" className="not-found-blob">
      <div className="display-text text-white">404</div>
      <div className="body-lg text-white">Page Not Found.</div>
      {!hideGoHome ? (
        <Button
          className="ls-button ls-button-primary has-primary mt-3"
          onClick={() => {
            window.location.href = window.location.origin;
          }}
        >
          Go Home
        </Button>
      ) : (
        ''
      )}
    </div>
  </div>
);

export default Error404Page;
